export const safeAdd = (a, b) => parseFloat((((a * 100) + (b * 100)) / 100).toFixed(2));
export const safeSub = (a, b) => parseFloat((((a * 100) - (b * 100)) / 100).toFixed(2));
export const safeMul = (value, multiplier) => (
  parseFloat((((value * 100) * multiplier) / 100).toFixed(2))
);
export const safeDiv = (value, divider) => (
  parseFloat((((value * 100) / divider) / 100).toFixed(2))
);
